import { ErrorBaseData } from '.'

export const kiraErrors: Record<string, ErrorBaseData> = {
  KiraNotSupportedDisease: {
    message: 'Doença não suportada',
    description: 'A assistente virtual Kira ainda não tem suporte para esta doença',
  },
}
